export default __webpack_public_path__ + "static/logo_white-69dd681c85463aaa3e5b723196129fc7.svg";